import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { player } from 'src/client/player';
import { seek } from 'src/common/actions/player';
import { PLAYER_MANAGER_ENABLED } from 'src/common/constants/experiments/config';
import useExperiment from 'src/common/hooks/useExperiment';
import { useStores } from 'src/common/providers';
import secondsToTime from 'src/common/utils/secondsToTime';
import useActions from '../../../../hooks/useActions';
import { selectIsMobile } from '../../../../selectors/app';
import { selectIsVideoAdDialogOpen } from '../../../../selectors/dialog';
import {
  selectCanScrub,
  selectPositionInfo,
  selectShowStartEnd,
} from '../../../../selectors/player';
import DefaultScrubber from './DefaultScrubber';
import LiveSeekScrubber from './LiveSeekScrubber';

const sliderMax = 100;

export default function Scrubber({ isInNowPlayingDialog, className }) {
  const { playerStore } = useStores();
  const metadata = playerStore.metadata();
  const isVideoAdLoaded = playerStore.isVideoAdLoaded();
  const isLive = (metadata?.isLive ?? true) || isVideoAdLoaded;
  const isPlayerManagerEnabled = useExperiment(PLAYER_MANAGER_ENABLED);
  const canScrub = useSelector(selectCanScrub);
  const showStartEnd = useSelector(selectShowStartEnd);
  const isMobile = useSelector(selectIsMobile);
  const isVideoAdDialogOpen = useSelector(selectIsVideoAdDialogOpen);
  const actions = useActions({ seek });
  const legacyPositionInfo = useSelector(selectPositionInfo);
  const newPositionInfo = {
    duration: playerStore.duration(),
    elapsedSeconds: playerStore.currentTime(),
    elapsedPercent: (playerStore.currentTime() / playerStore.duration()) * 100,
    isLiveSeekStream: metadata?.isLiveSeek,
  };
  const {
    duration,
    elapsedSeconds = 0,
    elapsedPercent = 0,
    isLiveSeekStream,
  } = isPlayerManagerEnabled ? newPositionInfo : legacyPositionInfo;
  const elapsedTime = secondsToTime(elapsedSeconds);
  const durationTime = secondsToTime(duration);

  if (isLiveSeekStream && !isMobile) {
    return (
      <LiveSeekScrubber
        canScrub={!isVideoAdDialogOpen}
        isLive={isLive}
        sliderMax={sliderMax}
        elapsedTime={elapsedTime}
        durationTime={durationTime}
        elapsedPercent={elapsedPercent}
        elapsedSeconds={elapsedSeconds}
        onChangeCommitted={
          isPlayerManagerEnabled ? player.seekTo : actions.seek
        }
      />
    );
  }

  return (
    <DefaultScrubber
      sliderMax={sliderMax}
      elapsedTime={elapsedTime}
      durationTime={durationTime}
      elapsedPercent={elapsedPercent}
      elapsedSeconds={elapsedSeconds}
      onChangeCommitted={isPlayerManagerEnabled ? player.seekTo : actions.seek}
      isInNowPlayingDialog={isInNowPlayingDialog}
      showStartEnd={showStartEnd && !isVideoAdDialogOpen}
      className={className}
      canScrub={canScrub && !isVideoAdDialogOpen}
      isLive={isLive}
      isPlayerManagerEnabled={isPlayerManagerEnabled}
    />
  );
}

Scrubber.propTypes = {
  isInNowPlayingDialog: PropTypes.bool,
  className: PropTypes.string,
};
